import { gql } from '@apollo/client';

export const UpdateNavBarStore = gql`
mutation UpdateNavBarStore($idStore: ID!, $content: contentNavBar!) {
  updateNavBarStore(idStore: $idStore, content: $content) {
    status
  }
}
`;